import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/supplier-groups/$groupId')({
    component: () => <Outlet />,
});
